import BaseService from './baseService';

class BillingCounterService extends BaseService {
  	async getBillingCounterByCompany(id, opts = {}) {
      this.endPoint = `/billing-counters/company/${id}`;
      return this.get(opts);
    }
}

export default new BillingCounterService();